import { contentAPI, checkoutAPI, storefrontAccessToken } from '../config';
import { getCookie } from './dom';
import * as queries from '../queries/index';

const getDataOptions = (body) => {
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	const previewCode = typeof window !== 'undefined' ? getCookie(previewCode) : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;

	if (!body.market) delete body.market;
	if (!body.pricelist) delete body.pricelist;
	if (!body.campaignSite) delete body.campaignSite;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers = {
			'api-authorization': process.env.API,
		};
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((resp) => console.log('DEBUG: resp', resp.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const getCheckoutOptions = (query, variables) => {
	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
		method: 'post',
	};

	const params = {
		query,
	};

	if (variables) params.variables = variables;
	fetchOptions.body = JSON.stringify(params);

	fetchOptions.headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-Shopify-Storefront-Access-Token': storefrontAccessToken(),
	};

	return fetchOptions;
};

const fetchCheckout = (query = '', variables = '', country = '') => (
	fetch(checkoutAPI(), getCheckoutOptions(queries[query], variables)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err))
);

export { fetchData, fetchCheckout };
